/**
 * DeductionSection Component
 * 일차감 정보 테이블 섹션
 */
import React from 'react';
import { DeductDto } from '../types/supplier.api.types';
import { getDeductTypeLabel } from '../utils/supplierDetailHelpers';
import Pagination from '@/shared/components/dataDisplay/Pagination';

interface DeductionSectionProps {
    deductions: DeductDto[];
    currentDeductions: DeductDto[];
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
}

const DeductionSection: React.FC<DeductionSectionProps> = ({
                                                               deductions,
                                                               currentDeductions,
                                                               currentPage,
                                                               totalPages,
                                                               onPageChange
                                                           }) => {
    return (
        <div className="detail-card">
            <div className="detail-card-header">
                <i className="fas fa-minus-circle card-icon"></i>
                <h3 className="card-title">일차감 정보</h3>
            </div>
            <div className="detail-card-body">
                <div className="table-container">
                    <table className="supplier-table">
                        <thead>
                        <tr>
                            <th className="text-center">NO</th>
                            <th>공제이름</th>
                            <th>공제타입</th>
                            <th>공제금액</th>
                            <th>적용일자</th>
                        </tr>
                        </thead>
                        <tbody>
                        {deductions.length === 0 ? (
                            <tr>
                                <td colSpan={5} className="text-center text-gray-600">
                                    등록된 일차감 정보가 없습니다.
                                </td>
                            </tr>
                        ) : (
                            currentDeductions.map((deduction, index) => (
                                <tr key={`${deduction.seqNo}_${deduction.startDay}_${index}`}>
                                    <td className="text-center">{(currentPage - 1) * 10 + index + 1}</td>
                                    <td>{deduction.deductName}</td>
                                    <td>{getDeductTypeLabel(deduction.deductType)}</td>
                                    <td>{deduction.deductAmt?.toLocaleString() || '0'}원</td>
                                    <td>{deduction.startDay}</td>
                                </tr>
                            ))
                        )}
                        </tbody>
                    </table>
                </div>
                {deductions.length > 0 && (
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={onPageChange}
                    />
                )}
            </div>
        </div>
    );
};

export default DeductionSection;
